// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3iB9P","errorLogs":"styles_errorLogs__2sSKT"};